<template>
  <div class="order-review-drawer">
    <ReviewPreviewer :review="review">
      <template #footer>
        <div class="order-review-drawer__meta">
          <span>{{ $t('Submitted on') }}</span>
          <span class="order-review-drawer__meta-value"> {{ submittedOn }}</span>
        </div>
        <div
          v-if="publishedOn"
          class="order-review-drawer__meta"
        >
          <span>{{ $t('Published on') }}</span>
          <span class="order-review-drawer__meta-value"> {{ publishedOn }}</span>
        </div>
      </template>
    </ReviewPreviewer>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DrawerComponentName } from '@monolith/legacy/store/drawer';
import { mapState } from 'vuex';
import ReviewPreviewer from '@monolith/legacy/components/review/review-previewer.vue';
import { formatDate } from '@monolith/legacy/services/date-locale';

export default defineComponent({
  name: DrawerComponentName.OrderReviewDrawer,
  components: {
    ReviewPreviewer,
  },
  computed: {
    ...mapState('reviews', ['review']),
    submittedOn(): string {
      return formatDate(this.review.created_at, 'PPpp');
    },
    publishedOn(): string {
      if (this.review?.published_at) {
        return formatDate(this.review.published_at, 'PPpp');
      }
      return null;
    },
  },
});
</script>

<style scoped lang="scss">
.order-review-drawer {
  @apply ds-px-4 ds-py-5;

  &__meta {
    @apply ds-mt-4 ds-font-basic ds-text-xs;
  }

  &__meta-value {
    @apply ds-text-neutral-700;
  }
}
</style>
